import React, { useContext, useEffect, useReducer } from 'react';
import reducer from './app-reducer';
import Constant from './constants';
import { useLocation } from 'react-router-dom';
import { profileData } from './data';

const AppContext = React.createContext();
const initialState = {
  authenticated: false,
  selectedPage: Constant.HOME_PAGE_ROUTE,
  sidebarOpen: false,
  profileData: profileData,
};

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  useEffect(() => {
    dispatch({ type: 'ROUTE_CHANGED', payload: location.pathname });
  }, [location]);
  const toggleSidebar = () => {
    dispatch({ type: 'TOGGLE_SIDEBAR' });
  };
  const handleLogin = () => {
    dispatch({ type: 'LOGIN' });
  };
  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AppContext.Provider
      value={{ ...state, toggleSidebar, handleLogin, handleLogout }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useAppContext = () => {
  return useContext(AppContext);
};

export { AppProvider, useAppContext };
